module.exports = __webpack_public_path__ + "img/head7.0b6eeb4c.png";